import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  HStack,
  Text,
  Avatar,
  Box,
  Divider,
  useColorModeValue
} from '@chakra-ui/react';
import { User } from '../types';
import UserAvatar from '../../../components/UserAvatar';

interface GroupChatMembersDialogProps {
  isOpen: boolean;
  onClose: () => void;
  groupChatMembers: User[];
}

export const GroupChatMembersDialog: React.FC<GroupChatMembersDialogProps> = ({
  isOpen,
  onClose,
  groupChatMembers
}) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');
  const secondaryText = useColorModeValue('gray.600', 'gray.400');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent bg={bgColor}>
        <ModalHeader color={textColor}>
          Group Members ({groupChatMembers.length})
        </ModalHeader>
        <ModalCloseButton color={textColor} />
        <ModalBody pb={6}>
          <VStack spacing={3} align="stretch">
            {groupChatMembers.map((member, index) => (
              <Box key={member.id}>
                <HStack spacing={3} p={2} borderRadius="md" _hover={{ bg: useColorModeValue('gray.50', 'gray.700') }}>
                  <UserAvatar 
                    user={member} 
                    canEdit={false} 
                    size="md"
                  />
                  <Box flex="1">
                    <Text fontWeight="medium" color={textColor}>
                      {member.username || member.email}
                    </Text>
                    {member.username && (
                      <Text fontSize="sm" color={secondaryText}>
                        {member.email}
                      </Text>
                    )}
                  </Box>
                </HStack>
                {index < groupChatMembers.length - 1 && (
                  <Divider borderColor={borderColor} />
                )}
              </Box>
            ))}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
